
import {h} from "preact";
import Breakdown from "./Breakdown";
import sumPartsByWeight from "../sum/sumPartsByWeight";
import useDateRange from "../hooks/useDateRange";
import {formatDateRange} from "../utils/dateRange";
import useStatusFilter from "../hooks/useStatusFilter";
import useTabOverrun from "../hooks/useTabOverrun";
import {isOverrun} from "../filters/overrun";


export type BreakdownByWeightProps = {
  part: string
}

export function BreakdownByWeight(props: BreakdownByWeightProps) {
  const {part} = props;
  const [dates, [], [interval], []] = useDateRange();
  const status = useStatusFilter();
  const tabOverrun = useTabOverrun();

  return <Breakdown
    title={`${part}`}
    description={ formatDateRange(dates, interval) + ", Weight (tonnes)" }
    filter={(quotes) => quotes.filter(q =>
      q.start >= dates[0][0]
      && q.start < dates[dates.length - 1][1]
      && status.includes(q.status)
      && (!tabOverrun || !isOverrun(q))
    )}
    sum={(items) => sumPartsByWeight(part, items).toString()}
  />
}

export default BreakdownByWeight;
